import { render, staticRenderFns } from "./BabylonViewer.vue?vue&type=template&id=04017fcc&scoped=true&"
import script from "./BabylonViewer.vue?vue&type=script&lang=ts&"
export * from "./BabylonViewer.vue?vue&type=script&lang=ts&"
import style0 from "./BabylonViewer.vue?vue&type=style&index=0&id=04017fcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04017fcc",
  null
  
)

export default component.exports